import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"   viewBox="0 0 719.000000 720.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,720.000000) scale(0.100000,-0.100000)">

<path d="M1372 5918 l3 -83 75 0 75 0 3 83 3 82 -81 0 -81 0 3 -82z"/>
<path d="M3547 5598 c-76 -133 -237 -426 -237 -431 0 -4 305 -7 678 -7 654 0
680 -1 752 -21 115 -32 185 -73 275 -164 138 -138 191 -278 182 -485 -3 -94
-10 -131 -34 -202 -101 -291 -377 -516 -691 -563 -108 -17 -817 -22 -826 -7
-3 5 13 92 35 193 103 477 120 558 130 611 9 45 37 100 140 270 l128 213 -251
3 c-193 2 -255 -1 -264 -10 -7 -7 -49 -76 -94 -153 -45 -77 -121 -206 -168
-288 -84 -141 -119 -202 -193 -331 -37 -64 -53 -77 -63 -49 -3 10 -18 38 -33
63 -43 72 -53 91 -148 255 -95 164 -144 237 -104 155 12 -25 26 -48 31 -51 5
-3 10 -15 11 -27 0 -12 3 -19 6 -17 4 5 31 -42 31 -54 -1 -3 -10 5 -22 19 -20
23 -20 21 -3 -21 5 -13 1 -16 -17 -14 -13 1 -23 3 -23 5 0 1 -12 4 -27 6 -30
5 -39 -12 -10 -18 13 -3 9 -9 -19 -26 -19 -12 -42 -33 -49 -47 -8 -15 -22 -25
-35 -25 -26 0 -72 -45 -56 -55 6 -3 9 -11 5 -16 -4 -6 -14 -3 -26 8 -20 18
-21 18 -9 -4 16 -32 13 -41 -5 -14 -12 17 -14 28 -7 45 8 16 7 25 -4 35 -19
17 -30 6 -13 -14 7 -9 10 -19 6 -22 -9 -9 -26 17 -26 40 0 10 -4 16 -9 12 -5
-3 -11 0 -13 7 -2 7 -52 98 -113 201 -60 103 -126 216 -145 250 -19 34 -40 70
-45 79 -9 15 -33 17 -194 18 -100 1 -185 -1 -188 -3 -4 -5 88 -161 667 -1126
l286 -476 274 1 c292 1 423 14 710 69 719 139 1409 458 1864 861 l89 79 -6
160 c-4 129 -11 179 -31 255 -44 162 -84 250 -171 380 -174 260 -422 421 -733
475 -68 12 -195 15 -628 15 l-543 0 -24 -42z"/>
<path d="M1340 5470 l0 -90 90 0 90 0 0 90 0 90 -90 0 -90 0 0 -90z"/>
<path d="M1640 5460 l0 -71 68 3 67 3 0 65 0 65 -67 3 -68 3 0 -71z"/>
<path d="M1600 5210 l0 -90 90 0 90 0 0 29 c0 29 2 30 52 33 l52 3 -3 48 c-2
36 1 48 14 53 21 8 25 3 32 -38 6 -39 13 -49 14 -22 1 16 2 15 7 -4 12 -39 27
-24 27 26 l0 47 -187 3 -188 2 0 -90z"/>
<path d="M5837 4999 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M5870 4980 c0 -6 7 -10 15 -10 8 0 15 2 15 4 0 2 -7 6 -15 10 -8 3
-15 1 -15 -4z"/>
<path d="M2726 4717 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z"/>
<path d="M2765 4580 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M4611 4314 c-1 -183 2 -253 11 -262 18 -18 104 -15 133 4 l25 16 -1
197 c0 108 -4 219 -9 246 l-7 50 -2 -41 c-1 -39 -19 -63 -35 -46 -4 3 -25 5
-46 3 -31 -2 -40 1 -40 13 0 9 -4 16 -9 16 -5 0 -12 12 -14 28 -2 15 -5 -86
-6 -224z"/>
<path d="M2730 4519 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M4500 4385 c-2 -46 -5 -57 -7 -32 -4 34 -6 36 -20 22 -17 -17 -73
-17 -85 0 -4 6 -8 -1 -9 -15 -1 -22 -2 -20 -12 10 -10 30 -12 10 -15 -134 -2
-116 1 -173 9 -182 14 -18 130 -19 147 -2 8 8 12 61 11 178 -1 178 -14 282
-19 155z"/>
<path d="M4150 4262 c0 -7 -4 -10 -10 -7 -5 3 -10 1 -10 -4 0 -6 -6 -10 -12
-8 -10 1 -13 -23 -13 -98 l0 -100 54 -3 c103 -6 101 -8 100 116 0 59 -3 101
-6 95 -2 -7 -20 -13 -39 -13 -24 0 -33 4 -28 12 5 7 3 8 -6 3 -7 -4 -16 -2
-21 6 -7 11 -9 11 -9 1z"/>
<path d="M2000 3958 c-303 -355 -150 -636 410 -752 185 -38 485 -60 715 -51
151 6 515 39 555 50 91 27 214 37 440 36 466 -3 624 24 879 146 98 47 193 106
239 151 8 6 23 17 34 23 11 6 17 17 14 25 -3 9 -1 12 4 9 6 -4 31 14 56 39 51
52 49 59 -5 19 -20 -15 -30 -19 -22 -9 13 15 13 19 0 27 -19 12 -36 11 -45 -2
-4 -8 0 -9 15 -4 23 7 30 -10 7 -18 -15 -6 -40 16 -30 26 12 12 -46 19 -60 8
-17 -14 -46 -4 -40 14 3 7 -29 -4 -73 -25 -43 -20 -103 -48 -133 -62 -30 -14
-84 -39 -120 -56 -83 -38 -374 -148 -443 -167 -220 -62 -229 -64 -250 -54 -20
8 -19 9 6 4 15 -3 27 -1 27 4 0 13 -27 21 -47 14 -12 -5 -14 -3 -8 7 6 10 2
12 -18 8 -14 -3 -31 -2 -37 2 -6 4 8 10 32 13 24 3 53 9 63 12 14 5 13 2 -4
-8 -20 -12 -21 -15 -7 -20 10 -4 15 -3 11 3 -4 6 8 13 26 17 28 5 30 7 14 14
-19 7 -19 8 1 8 12 1 24 7 27 15 4 11 -10 9 -62 -9 -37 -12 -88 -26 -112 -30
-31 -6 -39 -10 -26 -14 10 -4 -6 -7 -35 -7 -29 0 -82 -8 -117 -18 -252 -66
-813 -105 -1117 -77 -358 33 -594 111 -725 241 -56 55 -69 75 -84 125 -30 103
-2 219 81 341 24 35 42 64 39 64 -2 0 -36 -37 -75 -82z m2110 -614 c0 -2 -9
-4 -20 -4 -11 0 -20 4 -20 9 0 5 9 7 20 4 11 -3 20 -7 20 -9z"/>
<path d="M5271 3704 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M4205 3360 c3 -5 16 -10 28 -9 21 0 21 1 2 9 -28 12 -37 12 -30 0z"/>
<path d="M2677 2854 c-59 -18 -129 -84 -147 -138 -7 -21 -10 -66 -8 -101 7
-108 76 -183 190 -207 70 -15 154 2 199 39 l30 26 -26 28 -27 27 -47 -25
c-139 -75 -287 70 -210 207 25 45 83 80 131 80 19 0 56 -11 81 -25 l47 -24 26
26 27 27 -33 27 c-33 28 -105 50 -158 48 -15 0 -49 -7 -75 -15z"/>
<path d="M633 2828 c8 -18 48 -112 89 -208 41 -96 78 -183 81 -192 5 -14 18
-18 59 -18 l53 0 90 212 c50 117 91 218 93 225 3 9 -10 13 -45 13 l-48 0 -70
-169 c-38 -93 -71 -168 -73 -166 -2 1 -34 76 -71 166 l-69 164 -51 3 -52 3 14
-33z"/>
<path d="M1170 2635 l0 -225 161 0 160 0 -3 38 -3 37 -113 3 -113 3 3 52 3 52
100 5 100 5 0 35 0 35 -102 3 -103 3 0 49 0 49 113 3 112 3 3 38 3 37 -160 0
-161 0 0 -225z"/>
<path d="M1580 2635 l0 -225 45 0 45 0 0 81 0 80 37 -3 c33 -3 41 -10 87 -80
l51 -77 53 0 c28 -1 52 2 52 7 0 4 -25 40 -55 81 l-54 74 32 17 c61 33 87 117
58 188 -6 15 -31 40 -53 55 -40 26 -48 27 -170 27 l-128 0 0 -225z m250 125
c26 -26 26 -72 -1 -96 -15 -13 -40 -20 -90 -22 l-69 -4 0 71 0 71 70 0 c57 0
74 -4 90 -20z"/>
<path d="M2180 2814 c-11 -26 -20 -48 -20 -51 0 -2 -34 -80 -75 -174 -41 -93
-75 -171 -75 -174 0 -3 21 -5 48 -5 46 0 47 1 65 45 l19 45 109 0 110 0 19
-45 c19 -44 20 -45 65 -45 54 0 55 -6 -7 135 -21 50 -60 141 -86 202 l-47 113
-52 0 -52 0 -21 -46z m114 -152 c20 -46 36 -85 36 -87 0 -3 -34 -5 -75 -5 -41
0 -75 3 -75 8 0 8 56 148 66 163 8 13 6 16 48 -79z"/>
<path d="M3030 2635 l0 -225 45 0 45 0 0 225 0 225 -45 0 -45 0 0 -225z"/>
<path d="M3200 2820 l0 -40 70 0 70 0 0 -185 0 -185 45 0 45 0 0 185 0 185 75
0 75 0 0 40 0 40 -190 0 -190 0 0 -40z"/>
<path d="M3705 2731 l85 -128 0 -97 0 -96 45 0 45 0 0 94 0 95 85 128 86 128
-42 3 c-23 2 -47 1 -53 -1 -7 -3 -34 -41 -62 -86 -27 -45 -52 -81 -55 -81 -4
0 -31 38 -60 85 l-54 85 -52 0 -53 0 85 -129z"/>
<path d="M4160 2823 c-1 -62 -1 -366 -1 -390 1 -22 5 -23 89 -23 108 1 154 11
206 47 51 35 96 119 96 178 0 60 -45 143 -97 179 -47 33 -103 45 -215 45 l-78
1 0 -37z m241 -58 c43 -23 73 -88 66 -146 -11 -92 -57 -129 -169 -137 l-68 -5
0 158 0 158 71 -7 c39 -3 84 -13 100 -21z"/>
<path d="M4640 2635 l0 -225 40 0 40 0 0 225 0 225 -40 0 -40 0 0 -225z"/>
<path d="M4960 2844 c-86 -37 -136 -103 -147 -193 -10 -89 54 -190 146 -228
80 -34 198 -11 264 50 25 24 27 32 27 102 l0 76 -97 -3 c-95 -3 -98 -4 -101
-27 -5 -32 10 -39 69 -35 l49 4 0 -38 c0 -34 -4 -40 -35 -55 -46 -22 -121 -22
-165 1 -103 51 -101 220 2 273 53 27 134 23 178 -9 l29 -22 26 23 c26 22 26
23 8 39 -10 9 -36 25 -58 37 -48 25 -142 28 -195 5z"/>
<path d="M5354 2847 c-2 -7 -3 -107 -2 -222 l3 -210 38 -3 37 -3 0 225 0 226
-35 0 c-20 0 -38 -6 -41 -13z"/>
<path d="M5512 2843 c-19 -40 -10 -48 61 -51 l67 -3 0 -189 0 -190 40 0 40 0
0 190 0 190 71 0 70 0 -3 33 -3 32 -167 3 c-152 2 -168 1 -176 -15z"/>
<path d="M6033 2852 c-11 -7 -50 -89 -78 -162 -8 -19 -34 -84 -60 -145 -26
-60 -49 -116 -52 -123 -4 -10 5 -13 37 -10 41 3 44 5 59 46 l15 42 112 0 112
0 14 -42 c13 -39 18 -43 51 -46 27 -2 37 1 37 11 0 13 -31 92 -109 277 -18 41
-39 92 -48 113 -8 20 -20 37 -27 38 -6 0 -20 2 -31 4 -11 2 -25 1 -32 -3z m75
-184 c18 -43 32 -82 32 -88 0 -6 -31 -10 -75 -10 -41 0 -75 4 -75 8 0 5 12 37
26 73 15 35 30 75 36 88 11 31 18 23 56 -71z"/>
<path d="M6388 2853 c-23 -6 -23 -17 -20 -246 l3 -198 137 3 137 3 3 32 3 32
-103 3 -103 3 -5 185 c-5 195 -6 196 -52 183z"/>
<path d="M2303 2223 c-18 -7 -18 -254 -1 -271 16 -16 130 -16 146 0 17 17 17
249 0 266 -12 12 -120 16 -145 5z m92 -13 c-4 -6 5 -10 19 -10 l26 0 0 -110 0
-110 -25 0 c-16 0 -25 -6 -25 -15 0 -8 -7 -15 -15 -15 -8 0 -15 6 -15 14 0 9
-12 16 -27 18 l-28 3 0 110 0 110 29 -3 c18 -3 26 0 22 7 -5 7 3 11 19 11 15
0 24 -4 20 -10z"/>
<path d="M4100 2216 c0 -2 7 -9 15 -16 9 -7 15 -8 15 -2 0 5 -7 12 -15 16 -8
3 -15 4 -15 2z"/>
<path d="M4724 2184 c-18 -33 -18 -36 -1 -45 23 -13 22 -45 -3 -71 -24 -26
-26 -55 -3 -80 14 -16 14 -18 0 -18 -43 0 -64 82 -32 124 17 22 19 36 7 36
-16 0 -42 -59 -42 -95 0 -26 7 -43 25 -59 48 -45 104 -40 145 11 28 36 23 89
-17 145 -15 22 -35 51 -44 64 l-16 24 -19 -36z"/>
<path d="M2945 2203 c-46 -9 -85 -25 -109 -44 -40 -31 -21 -40 27 -14 23 13
65 26 92 30 43 5 58 2 107 -23 32 -16 60 -27 63 -24 12 12 2 23 -42 45 -50 25
-104 36 -138 30z"/>
<path d="M3600 2203 c0 -5 -25 -36 -55 -70 -30 -33 -55 -64 -55 -67 0 -3 16
-6 35 -6 40 0 40 -2 20 -60 -21 -58 -20 -59 19 -14 18 21 48 55 65 74 40 45
39 53 -4 48 -40 -5 -40 -6 -21 55 8 26 10 47 5 47 -5 0 -9 -3 -9 -7z"/>
<path d="M4170 2185 c-7 -8 -16 -12 -21 -9 -5 3 -9 0 -9 -6 0 -6 -12 -11 -27
-10 -16 1 -45 2 -65 1 l-38 -1 0 -88 c0 -55 4 -92 12 -100 13 -13 232 -18 262
-6 13 5 16 24 16 100 l0 94 -58 0 c-64 0 -78 6 -61 27 6 7 9 13 6 13 -2 0 -10
-7 -17 -15z m115 -120 l0 -80 -127 -3 -128 -3 0 86 0 86 128 -3 127 -3 0 -80z"/>
<path d="M2921 2125 c-45 -20 -62 -35 -55 -47 3 -5 15 -1 26 9 27 24 128 25
155 1 23 -21 33 -23 33 -5 0 7 -12 20 -27 29 -43 25 -93 30 -132 13z"/>
<path d="M2018 2093 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z"/>
<path d="M2928 2059 c-31 -18 -19 -24 47 -24 70 0 79 5 40 23 -31 15 -64 15
-87 1z"/>
<path d="M2955 2001 c-8 -15 3 -31 21 -31 9 0 14 7 12 17 -4 20 -24 28 -33 14z"/>
<path d="M1382 1698 c3 -47 6 -53 26 -56 31 -5 72 23 72 49 0 41 -18 59 -61
59 l-40 0 3 -52z m73 12 c8 -25 -10 -50 -36 -50 -15 0 -19 7 -19 35 0 30 3 35
24 35 16 0 27 -7 31 -20z"/>
<path d="M1541 1698 c-22 -54 -21 -75 4 -42 13 18 15 18 45 2 35 -20 37 -13
14 49 -9 24 -22 43 -29 43 -7 0 -22 -23 -34 -52z m49 -10 c0 -5 -7 -8 -15 -8
-15 0 -20 21 -8 33 7 7 23 -11 23 -25z"/>
<path d="M1660 1740 c0 -5 7 -10 15 -10 11 0 15 -12 15 -45 0 -25 5 -45 10
-45 6 0 10 20 10 45 0 33 4 45 14 45 8 0 18 5 21 10 4 6 -12 10 -39 10 -25 0
-46 -4 -46 -10z"/>
<path d="M1800 1704 c-11 -25 -20 -50 -20 -55 0 -15 17 -10 24 6 7 20 35 19
58 -2 10 -9 18 -11 18 -6 0 20 -41 103 -51 103 -5 0 -19 -21 -29 -46z m36 -21
c-11 -11 -19 6 -11 24 8 17 8 17 12 0 3 -10 2 -21 -1 -24z"/>
<path d="M2226 1707 c-22 -58 -21 -75 2 -54 24 22 48 22 61 0 5 -10 12 -15 15
-12 10 9 -35 109 -49 109 -7 0 -20 -19 -29 -43z m44 -13 c0 -8 -7 -14 -15 -14
-17 0 -18 2 -9 24 7 18 24 12 24 -10z"/>
<path d="M2360 1695 c0 -30 5 -55 10 -55 6 0 10 25 10 55 0 30 -4 55 -10 55
-5 0 -10 -25 -10 -55z"/>
<path d="M2440 1695 c0 -30 5 -55 10 -55 6 0 10 9 10 20 0 11 4 20 10 20 5 0
15 -9 22 -20 16 -26 31 -26 23 0 -3 11 -2 27 4 37 16 29 -5 53 -44 53 l-35 0
0 -55z m60 20 c0 -8 -9 -15 -20 -15 -11 0 -20 7 -20 15 0 8 9 15 20 15 11 0
20 -7 20 -15z"/>
<path d="M2575 1740 c3 -5 13 -10 21 -10 10 0 14 -13 14 -47 0 -57 8 -53 11 5
2 33 7 42 21 42 10 0 18 5 18 10 0 6 -21 10 -46 10 -27 0 -43 -4 -39 -10z"/>
<path d="M2710 1695 c0 -30 5 -55 10 -55 6 0 10 25 10 55 0 30 -4 55 -10 55
-5 0 -10 -25 -10 -55z"/>
<path d="M2790 1695 c0 -30 5 -55 10 -55 6 0 10 15 10 33 l0 32 19 -24 19 -24
15 29 16 29 1 -37 c0 -21 5 -38 10 -38 6 0 10 25 10 55 0 42 -3 55 -15 55 -8
0 -15 -4 -15 -8 0 -5 -6 -17 -14 -27 -14 -19 -15 -19 -27 8 -21 46 -39 34 -39
-28z"/>
<path d="M2960 1695 l0 -55 40 0 c22 0 40 5 40 10 0 6 -13 10 -30 10 -20 0
-30 5 -30 15 0 9 9 15 25 15 14 0 25 5 25 10 0 6 -11 10 -25 10 -14 0 -25 5
-25 10 0 6 11 10 24 10 14 0 28 5 31 10 4 6 -10 10 -34 10 l-41 0 0 -55z"/>
<path d="M3350 1740 c0 -5 7 -10 15 -10 11 0 15 -11 15 -39 0 -52 20 -65 21
-14 1 21 1 41 0 46 0 4 8 7 19 7 11 0 20 5 20 10 0 6 -20 10 -45 10 -25 0 -45
-4 -45 -10z"/>
<path d="M3486 1728 c17 -53 36 -89 46 -86 12 4 51 98 44 105 -10 10 -25 -8
-31 -37 -9 -40 -21 -38 -35 5 -6 19 -16 35 -21 35 -6 0 -7 -9 -3 -22z"/>
<path d="M3892 1698 l3 -53 38 -3 c41 -4 52 15 12 20 -33 4 -33 22 0 26 31 4
23 22 -11 22 -13 0 -24 5 -24 10 0 6 14 10 30 10 17 0 30 5 30 10 0 6 -18 10
-41 10 l-40 0 3 -52z"/>
<path d="M4020 1695 l0 -55 35 0 c19 0 35 5 35 10 0 6 -11 10 -25 10 -23 0
-25 4 -25 45 0 25 -4 45 -10 45 -5 0 -10 -25 -10 -55z"/>
<path d="M4130 1695 l0 -55 40 0 c22 0 40 5 40 10 0 6 -13 10 -30 10 -20 0
-30 5 -30 15 0 9 9 15 25 15 14 0 25 5 25 10 0 6 -11 10 -25 10 -14 0 -25 5
-25 10 0 6 11 10 24 10 14 0 28 5 31 10 4 6 -10 10 -34 10 l-41 0 0 -55z"/>
<path d="M4260 1731 c-17 -32 -12 -60 15 -77 26 -17 56 -16 62 3 3 8 -5 11
-22 10 -31 -2 -52 21 -42 47 4 11 18 16 42 16 22 0 34 4 30 10 -11 18 -73 12
-85 -9z"/>
<path d="M4385 1740 c3 -5 13 -10 21 -10 10 0 14 -12 14 -45 0 -25 5 -45 10
-45 6 0 10 20 10 45 0 33 4 45 15 45 8 0 15 5 15 10 0 6 -21 10 -46 10 -27 0
-43 -4 -39 -10z"/>
<path d="M4510 1701 c0 -28 5 -53 10 -56 6 -3 10 3 10 14 0 27 21 27 38 1 16
-27 36 -27 22 0 -7 14 -7 25 1 38 20 32 4 52 -41 52 l-40 0 0 -49z m67 15 c-6
-17 -47 -20 -47 -3 0 9 6 17 13 20 18 6 38 -4 34 -17z"/>
<path d="M4650 1694 c0 -34 4 -53 10 -49 6 3 10 28 10 56 0 27 -4 49 -10 49
-5 0 -10 -25 -10 -56z"/>
<path d="M4726 1734 c-24 -23 -20 -61 9 -80 26 -17 56 -16 62 2 2 7 -5 10 -20
7 -29 -6 -51 19 -42 47 5 15 15 20 41 20 21 0 33 4 29 10 -10 16 -62 12 -79
-6z"/>
<path d="M4850 1695 c0 -30 5 -55 10 -55 6 0 10 25 10 55 0 30 -4 55 -10 55
-5 0 -10 -25 -10 -55z"/>
<path d="M4915 1740 c3 -5 12 -10 19 -10 8 0 11 -10 8 -30 -2 -16 -1 -38 2
-47 11 -27 24 2 21 43 -3 24 1 34 10 34 8 0 17 5 20 10 4 6 -12 10 -40 10 -28
0 -44 -4 -40 -10z"/>
<path d="M5049 1714 c12 -19 21 -44 21 -55 0 -11 5 -17 10 -14 6 3 10 15 10
26 0 11 7 31 16 45 21 31 8 46 -14 16 -17 -22 -17 -22 -30 -2 -22 36 -35 21
-13 -16z"/>
<path d="M5430 1694 c0 -34 4 -53 10 -49 6 3 10 18 10 33 l0 26 17 -23 16 -24
16 29 16 29 3 -38 c5 -54 22 -35 22 24 0 55 -18 66 -40 24 -7 -14 -16 -25 -20
-25 -4 0 -12 11 -18 25 -19 41 -32 29 -32 -31z"/>
<path d="M5595 1726 c-30 -45 8 -95 61 -82 59 15 49 98 -13 104 -25 3 -35 -2
-48 -22z m70 -31 c0 -23 -5 -31 -22 -33 -14 -2 -26 4 -32 17 -16 30 -3 53 28
49 22 -2 26 -8 26 -33z"/>
<path d="M5740 1695 c0 -30 5 -55 10 -55 6 0 10 9 10 20 0 11 6 20 13 20 7 0
18 -9 25 -20 7 -11 17 -20 23 -20 8 0 7 5 -1 15 -11 13 -11 20 0 40 18 33 -1
55 -46 55 l-34 0 0 -55z m65 20 c0 -5 -10 -11 -22 -13 -16 -2 -23 2 -23 13 0
11 7 15 23 13 12 -2 22 -7 22 -13z"/>
<path d="M5872 1698 l3 -53 38 -3 c21 -2 37 1 37 7 0 6 -11 11 -25 11 -16 0
-25 6 -25 15 0 9 10 15 26 15 14 0 23 4 19 10 -3 6 -15 10 -26 10 -10 0 -19 5
-19 10 0 6 11 10 25 10 14 0 25 5 25 10 0 6 -18 10 -41 10 l-40 0 3 -52z"/>
<path d="M2024 1705 c-7 -18 3 -35 21 -35 18 0 26 15 19 34 -8 20 -33 21 -40
1z"/>
<path d="M3181 1711 c-19 -12 -6 -43 16 -39 10 2 18 12 18 22 0 22 -14 29 -34
17z"/>
<path d="M3714 1705 c-4 -9 -2 -21 4 -27 15 -15 44 -1 40 19 -4 23 -36 29 -44
8z"/>
<path d="M5254 1706 c-7 -19 3 -36 22 -36 10 0 14 8 12 22 -4 26 -26 36 -34
14z"/>
<path d="M2380 1390 c0 -27 5 -50 10 -50 6 0 10 9 10 19 0 12 8 21 23 24 l22
4 -22 2 c-35 2 -31 39 5 44 22 3 20 4 -10 6 l-38 1 0 -50z"/>
<path d="M2520 1394 c-23 -53 -25 -63 -8 -46 15 15 68 16 68 0 0 -6 3 -9 6 -5
8 8 -26 97 -38 97 -5 0 -18 -21 -28 -46z m40 -5 c0 -10 -7 -19 -15 -19 -16 0
-19 9 -9 34 8 20 24 11 24 -15z"/>
<path d="M2660 1425 c-10 -12 -6 -18 24 -36 42 -24 38 -44 -7 -35 -23 5 -28 3
-20 -5 17 -17 67 -7 71 14 3 13 -6 22 -27 30 -38 14 -43 42 -6 35 14 -3 25 -1
25 3 0 15 -47 10 -60 -6z"/>
<path d="M2802 1430 c12 -8 15 -19 11 -50 -4 -26 -2 -40 6 -40 6 0 11 18 11
44 0 34 4 46 18 49 9 3 -1 5 -23 6 -30 0 -36 -2 -23 -9z"/>
<path d="M3077 1433 c-15 -14 -6 -33 23 -48 35 -18 30 -39 -6 -32 -13 2 -24 0
-24 -5 0 -5 15 -8 32 -6 45 4 49 32 9 53 -37 19 -41 39 -6 33 14 -3 25 -1 25
3 0 10 -44 12 -53 2z"/>
<path d="M3200 1390 l0 -50 38 2 c36 1 36 1 5 5 -23 3 -30 8 -26 19 3 8 14 14
24 14 10 0 19 5 19 11 0 6 -9 9 -20 6 -15 -4 -20 0 -20 13 0 13 9 20 28 23 22
3 20 4 -10 6 l-38 1 0 -50z"/>
<path d="M3347 1422 c-22 -24 -21 -45 1 -65 20 -18 57 -23 66 -8 3 5 -9 8 -27
7 -30 -1 -32 1 -32 34 0 32 3 35 28 35 15 -1 27 3 27 7 0 15 -47 8 -63 -10z"/>
<path d="M3484 1399 c2 -83 70 -80 72 2 l1 44 -4 -40 c-5 -48 -14 -59 -41 -50
-15 4 -22 17 -25 46 l-4 39 1 -41z"/>
<path d="M3631 1388 c0 -42 2 -48 9 -30 5 12 12 22 14 22 3 0 15 -10 27 -22
19 -20 20 -20 11 -3 -8 15 -7 24 5 37 21 24 1 48 -38 48 -28 0 -29 -1 -28 -52z
m57 20 c3 -13 -3 -18 -22 -18 -20 0 -26 5 -26 21 0 15 5 20 22 17 13 -2 24
-11 26 -20z"/>
<path d="M3770 1390 l0 -50 38 2 c34 1 35 1 6 5 -29 4 -31 7 -31 43 0 36 2 39
31 43 29 4 28 4 -6 5 l-38 2 0 -50z"/>
<path d="M4061 1388 c1 -36 3 -45 8 -30 l6 24 28 -22 c27 -21 38 -15 15 8 -8
8 -8 12 -1 12 17 0 25 31 12 46 -6 8 -24 14 -40 14 -28 0 -29 -1 -28 -52z m57
20 c3 -13 -3 -18 -22 -18 -20 0 -26 5 -26 21 0 15 5 20 22 17 13 -2 24 -11 26
-20z"/>
<path d="M4200 1390 l0 -50 38 2 c36 1 36 1 5 5 -30 4 -32 6 -29 41 2 32 6 38
31 43 29 6 28 7 -7 8 l-38 1 0 -50z"/>
<path d="M4332 1393 l-2 -53 38 2 c36 1 36 1 5 5 -30 4 -32 7 -36 51 l-3 47
-2 -52z"/>
<path d="M4450 1396 c0 -25 5 -48 10 -51 6 -4 10 13 10 44 0 28 -4 51 -10 51
-5 0 -10 -20 -10 -44z"/>
<path d="M4550 1394 c-23 -53 -25 -63 -8 -46 15 15 68 16 68 0 0 -6 2 -9 5 -6
8 7 -26 98 -36 98 -5 0 -19 -21 -29 -46z m40 -4 c0 -11 -7 -20 -15 -20 -15 0
-21 21 -8 33 12 13 23 7 23 -13z"/>
<path d="M4690 1391 c0 -49 1 -51 28 -51 39 0 50 15 43 58 -6 33 -10 37 -39
40 l-32 3 0 -50z m58 22 c2 -7 -3 -13 -12 -13 -8 0 -18 -5 -21 -10 -4 -6 -3
-10 2 -9 21 4 33 -2 33 -16 0 -9 -9 -15 -25 -15 -23 0 -25 4 -25 41 0 36 2 40
22 37 12 -2 23 -9 26 -15z"/>
<path d="M4832 1393 l-2 -53 33 1 c29 2 29 2 5 6 -24 4 -27 9 -31 51 l-3 47
-2 -52z"/>
<path d="M4950 1390 l0 -50 38 1 c27 1 31 3 12 6 -31 6 -38 16 -32 53 3 22 10
30 31 33 20 3 17 4 -11 6 l-38 1 0 -50z"/>
<path d="M3800 1390 c0 -5 7 -10 16 -10 8 0 12 5 9 10 -3 6 -10 10 -16 10 -5
0 -9 -4 -9 -10z"/>
<path d="M4230 1390 c0 -5 7 -10 16 -10 8 0 12 5 9 10 -3 6 -10 10 -16 10 -5
0 -9 -4 -9 -10z"/>
<path d="M4980 1392 c0 -5 7 -9 15 -9 8 0 15 4 15 9 0 4 -7 8 -15 8 -8 0 -15
-4 -15 -8z"/>
<path d="M1801 1386 c2 -2 84 -7 182 -11 125 -5 177 -4 177 4 0 8 -57 11 -182
11 -100 0 -179 -2 -177 -4z"/>
<path d="M5277 1379 c9 -9 54 -9 170 -2 l158 10 -169 1 c-126 2 -167 -1 -159
-9z"/>
</g>
</svg>






    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
